import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=5faf8ffc&scoped=true&"
import script from "./GroupView.vue?vue&type=script&lang=js&"
export * from "./GroupView.vue?vue&type=script&lang=js&"
import style0 from "./GroupView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GroupView.vue?vue&type=style&index=1&id=5faf8ffc&lang=scss&scoped=true&"
import style2 from "./GroupView.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf8ffc",
  null
  
)

export default component.exports